const data = [
    {
    key: 1,
    img: require("./images/2.jpg"),
    uri: {uri: '2.tif'},
    },
    {
      key: 2,
      img: require("./images/3.jpg"),
      uri: {uri: '3.tif'},
    },
    {
      key: 3,
      img: require("./images/6.jpg"),
      uri: {uri: '6.tif'},
    },
    {
      key: 4,
      img: require("./images/7.jpg"),
      uri: {uri: '7.tif'},
    },
    {
      key: 5,
      img: require("./images/9.jpg"),
      uri: {uri: '9.tif'},
    },
    {
      key: 6,
      img: require("./images/10.jpg"),
      uri: {uri: '10.tif'},
    },
    {
      key: 7,
      img: require("./images/12.jpg"),
      uri: {uri: '12.tif'},
    },
    {
      key: 8,
      img: require("./images/12za.jpg"),
      uri: {uri: '12za.jpg'},
    },
    {
      key: 9,
      img: require("./images/14.jpg"),
      uri: {uri: '14.tif'},
    },
    {
      key: 10,
      img: require("./images/15.jpg"),
      uri: {uri: '15.pdf'},
    },
    {
      key: 11,
      img: require("./images/16.jpg"),
      uri: {uri: '16.tif'},
    },
    {
      key: 12,
      img: require("./images/17.jpg"),
      uri: {uri: '17.pdf'},
    },
    {
      key: 13,
      img: require("./images/18.jpg"),
      uri: {uri: '18.pdf'},
    },
    {
      key: 14,
      img: require("./images/19.jpg"),
      uri: {uri: '19.pdf'},
    },
    {
      key: 15,
      img: require("./images/20.jpg"),
      uri: {uri: '20.pdf'},
    },
    {
      key: 16,
      img: require("./images/21.jpg"),
      uri: {uri: '21.pdf'},
    },
    {
      key: 17,
      img: require("./images/22.jpg"),
      uri: {uri: '22.pdf'},
    },
    {
      key: 18,
      img: require("./images/23.jpg"),
      uri: {uri: '23.pdf'},
    },
    {
      key: 19,
      img: require("./images/23v2.jpg"),
      uri: {uri: '23v2.pdf'},
    },
    {
      key: 20,
      img: require("./images/24.jpg"),
      uri: {uri: '24.pdf'},
    },
    {
      key: 21,
      img: require("./images/25.jpg"),
      uri: {uri: '25.pdf'},
    },
    {
      key: 22,
      img: require("./images/26.jpg"),
      uri: {uri: '26.pdf'},
    },
    {
      key: 23,
      img: require("./images/27.jpg"),
      uri: {uri: '27v2.pdf'},
    },
    {
      key: 24,
      img: require("./images/28.jpg"),
      uri: {uri: '28.pdf'},
    },
    {
      key: 25,
      img: require("./images/28v2.jpg"),
      uri: {uri: '28v2.pdf'},
    },
    {
      key: 26,
      img: require("./images/29.jpg"),
      uri: {uri: '29.pdf'},
    },
    {
      key: 27,
      img: require("./images/30.jpg"),
      uri: {uri: '30.pdf'},
    },
    {
      key: 28,
      img: require("./images/31.jpg"),
      uri: {uri: '31.pdf'},
    },
    {
      key: 29,
      img: require("./images/32.jpg"),
      uri: {uri: '32.pdf'},
    },
    {
      key: 30,
      img: require("./images/33.jpg"),
      uri: {uri: '33.pdf'},
    },
    {
      key: 31,
      img: require("./images/34.jpg"),
      uri: {uri: '34.pdf'},
    },
    {
      key: 32,
      img: require("./images/35.jpg"),
      uri: {uri: '35.pdf'},
    },
    {
      key: 33,
      img: require("./images/36.jpg"),
      uri: {uri: '36.pdf'},
    },
    {
      key: 34,
      img: require("./images/37.jpg"),
      uri: {uri: '37.pdf'},
    },
    {
      key: 35,
      img: require("./images/38.jpg"),
      uri: {uri: '38.pdf'},
    },
    {
      key: 36,
      img: require("./images/38v2.jpg"),
      uri: {uri: '38v2.pdf'},
    },
    {
      key: 37,
      img: require("./images/39.jpg"),
      uri: {uri: '39.pdf'},
    },
    {
      key: 38,
      img: require("./images/40.jpg"),
      uri: {uri: '40.pdf'},
    },
    {
      key: 39,
      img: require("./images/41.jpg"),
      uri: {uri: '41.pdf'},
    },
    {
      key: 40,
      img: require("./images/42.jpg"),
      uri: {uri: '42.pdf'},
    },
    {
      key: 41,
      img: require("./images/42v2.jpg"),
      uri: {uri: '42v2.pdf'},
    },
    {
      key: 42,
      img: require("./images/43.jpg"),
      uri: {uri: '43.pdf'},
    },
    {
      key: 43,
      img: require("./images/44.jpg"),
      uri: {uri: '44.pdf'},
    },
    {
      key: 44,
      img: require("./images/45.jpg"),
      uri: {uri: '45.pdf'},
    },
    {
      key: 45,
      img: require("./images/46.jpg"),
      uri: {uri: '46.pdf'},
    },
    {
      key: 46,
      img: require("./images/48.jpg"),
      uri: {uri: '48.pdf'},
    },
    {
      key: 47,
      img: require("./images/49.jpg"),
      uri: {uri: '49.pdf'},
    },
    {
      key: 48,
      img: require("./images/61.jpg"),
      uri: {uri: '61.pdf'},
    },
    {
      key: 49,
      img: require("./images/62berceni.jpg"),
      uri: {uri: '62berceni.pdf'},
    },
    {
      key: 50,
      img: require("./images/62drumultaberei.jpg"),
      uri: {uri: '62drumul.pdf'},
    },
    {
      key: 51,
      img: require("./images/62ghencea.jpg"),
      uri: {uri: '62ghencea.pdf'},
    },
    {
      key: 52,
      img: require("./images/62militari.jpg"),
      uri: {uri: '62militari.pdf'},
    },
    {
      key: 53,
      img: require("./images/62pantelimon.jpg"),
      uri: {uri: '62Pantelimon.pdf'},
    },
    {
      key: 54,
      img: require("./images/62rahova.jpg"),
      uri: {uri: '62RAHOVA.pdf'},
    },
    {
      key: 55,
      img: require("./images/63.jpg"),
      uri: {uri: '63.pdf'},
    },
    {
      key: 54,
      img: require("./images/65.jpg"),
      uri: {uri: '65.pdf'},
    },
    {
      key: 55,
      img: require("./images/66.jpg"),
      uri: {uri: '66.pdf'},
    },
    {
      key: 56,
      img: require("./images/67.jpg"),
      uri: {uri: '67.pdf'},
    },
    {
      key: 57,
      img: require("./images/68.jpg"),
      uri: {uri: '68.pdf'},
    },
    {
      key: 58,
      img: require("./images/69.jpg"),
      uri: {uri: '69.pdf'},
    },
    {
      key: 59,
      img: require("./images/70.jpg"),
      uri: {uri: '70.pdf'},
    },
    {
      key: 60,
      img: require("./images/71.jpg"),
      uri: {uri: '71.pdf'},
    },
    {
      key: 61,
      img: require("./images/72.jpg"),
      uri: {uri: '72.pdf'},
    },
    {
      key: 62,
      img: require("./images/73.jpg"),
      uri: {uri: '73.pdf'},
    },
    {
      key: 63,
      img: require("./images/74.jpg"),
      uri: {uri: '74.pdf'},
    },
    {
      key: 64,
      img: require("./images/75.jpg"),
      uri: {uri: '75.pdf'},
    },
    {
      key: 65,
      img: require("./images/76.jpg"),
      uri: {uri: '156.pdf'},
    },
    {
      key: 66,
      img: require("./images/77.jpg"),
      uri: {uri: '156.pdf'},
    },
    {
      key: 67,
      img: require("./images/78.jpg"),
      uri: {uri: '78.pdf'},
    },
    {
      key: 68,
      img: require("./images/79.jpg"),
      uri: {uri: '79.pdf'},
    },
    {
      key: 69,
      img: require("./images/81.jpg"),
      uri: {uri: '81.pdf'},
    },
    {
      key: 70,
      img: require("./images/83.jpg"),
      uri: {uri: '83.pdf'},
    },
    {
      key: 71,
      img: require("./images/86.jpg"),
      uri: {uri: '86.pdf'},
    },
    {
      key: 72,
      img: require("./images/87.jpg"),
      uri: {uri: '88.pdf'},
    },
    {
      key: 73,
      img: require("./images/88.jpg"),
      uri: {uri: '88.pdf'},
    },
    {
      key: 74,
      img: require("./images/89.jpg"),
      uri: {uri: '89.pdf'},
    },
    {
      key: 75,
      img: require("./images/90.jpg"),
      uri: {uri: '90.pdf'},
    },
    {
      key: 76,
      img: require("./images/91.jpg"),
      uri: {uri: '91.pdf'},
    },
    {
      key: 77,
      img: require("./images/92.jpg"),
      uri: {uri: '92.pdf'},
    },
    {
      key: 78,
      img: require("./images/93.jpg"),
      uri: {uri: '93.pdf'},
    },
    {
      key: 79,
      img: require("./images/94.jpg"),
      uri: {uri: '94.pdf'},
    },
    {
      key: 80,
      img: require("./images/95casual.jpg"),
      uri: {uri: '95casual.pdf'},
    },
    {
      key: 81,
      img: require("./images/95hooligan.jpg"),
      uri: {uri: '95hooligan.pdf'},
    },
    {
      key: 82,
      img: require("./images/95ultra.jpg"),
      uri: {uri: '95ultra.pdf'},
    },
    {
      key: 83,
      img: require("./images/96.jpg"),
      uri: {uri: '96.pdf'},
    },
    {
      key: 84,
      img: require("./images/97.jpg"),
      uri: {uri: '97.pdf'},
    },
    {
      key: 85,
      img: require("./images/98.jpg"),
      uri: {uri: '98.pdf'},
    },
    {
      key: 86,
      img: require("./images/99.jpg"),
      uri: {uri: '99.pdf'},
    },
    {
      key: 87,
      img: require("./images/100.jpg"),
      uri: {uri: '100.pdf'},
    },
    {
      key: 88,
      img: require("./images/101.jpg"),
      uri: {uri: '101.pdf'},
    },
    {
      key: 89,
      img: require("./images/102.jpg"),
      uri: {uri: '102.pdf'},
    },
    {
      key: 90,
      img: require("./images/103.jpg"),
      uri: {uri: '103.pdf'},
    },
    {
      key: 91,
      img: require("./images/104.jpg"),
      uri: {uri: '104.pdf'},
    },
    {
      key: 92,
      img: require("./images/105.jpg"),
      uri: {uri: '105.pdf'},
    },
    {
      key: 93,
      img: require("./images/106.jpg"),
      uri: {uri: '106.pdf'},
    },
    {
      key: 94,
      img: require("./images/107.jpg"),
      uri: {uri: '107.pdf'},
    },
    {
      key: 95,
      img: require("./images/108.jpg"),
      uri: {uri: '108.pdf'},
    },
    {
      key: 96,
      img: require("./images/109.jpg"),
      uri: {uri: '109.pdf'},
    },
    {
      key: 97,
      img: require("./images/110.jpg"),
      uri: {uri: '110.pdf'},
    },
    {
      key: 98,
      img: require("./images/111.jpg"),
      uri: {uri: '111.pdf'},
    },
    {
      key: 99,
      img: require("./images/112.jpg"),
      uri: {uri: '112.pdf'},
    },
    {
      key: 100,
      img: require("./images/113.jpg"),
      uri: {uri: '113.pdf'},
    },
    {
      key: 101,
      img: require("./images/114.jpg"),
      uri: {uri: '114v2.pdf'},
    },
    {
      key: 102,
      img: require("./images/115.jpg"),
      uri: {uri: '115.pdf'},
    },
    {
      key: 103,
      img: require("./images/116.jpg"),
      uri: {uri: '116.pdf'},
    },
    {
      key: 104,
      img: require("./images/117.jpg"),
      uri: {uri: '117.pdf'},
    },
    {
      key: 105,
      img: require("./images/118.jpg"),
      uri: {uri: '118.pdf'},
    },
    {
      key: 106,
      img: require("./images/119.jpg"),
      uri: {uri: '119.pdf'},
    },
    {
      key: 107,
      img: require("./images/120.jpg"),
      uri: {uri: '120.pdf'},
    },
    {
      key: 108,
      img: require("./images/121.jpg"),
      uri: {uri: '121.pdf'},
    },
    {
      key: 109,
      img: require("./images/122.jpg"),
      uri: {uri: '122.pdf'},
    },
    {
      key: 110,
      img: require("./images/123.jpg"),
      uri: {uri: '123.pdf'},
    },
    {
      key: 111,
      img: require("./images/124.jpg"),
      uri: {uri: '124.pdf'},
    },
    {
      key: 112,
      img: require("./images/126.jpg"),
      uri: {uri: '126.pdf'},
    },
    {
      key: 113,
      img: require("./images/128.jpg"),
      uri: {uri: '128.pdf'},
    },
    {
      key: 114,
      img: require("./images/129.jpg"),
      uri: {uri: '129.pdf'},
    },
    {
      key: 115,
      img: require("./images/130.jpg"),
      uri: {uri: '130.pdf'},
    },
    {
      key: 116,
      img: require("./images/131.jpg"),
      uri: {uri: '131sfinx.pdf'},
    },
    {
      key: 117,
      img: require("./images/132.jpg"),
      uri: {uri: '132.pdf'},
    },
    {
      key: 118,
      img: require("./images/134.jpg"),
      uri: {uri: '134.pdf'},
    },
    {
      key: 119,
      img: require("./images/135.jpg"),
      uri: {uri: '135.pdf'},
    },
    {
      key: 120,
      img: require("./images/136.jpg"),
      uri: {uri: '136.pdf'},
    },
    {
      key: 121,
      img: require("./images/137.jpg"),
      uri: {uri: '137.pdf'},
    },
    {
      key: 122,
      img: require("./images/138.jpg"),
      uri: {uri: '138.pdf'},
    },
    {
      key: 123,
      img: require("./images/139.jpg"),
      uri: {uri: '139.pdf'},
    },
    {
      key: 124,
      img: require("./images/140.jpg"),
      uri: {uri: '140.pdf'},
    },
    {
      key: 125,
      img: require("./images/141.jpg"),
      uri: {uri: '141.pdf'},
    },
    {
      key: 126,
      img: require("./images/141v1.jpg"),
      uri: {uri: '141v1.pdf'},
    },
    {
      key: 127,
      img: require("./images/142.jpg"),
      uri: {uri: '142.pdf'},
    },
    {
      key: 128,
      img: require("./images/143.jpg"),
      uri: {uri: '143.pdf'},
    },
    {
      key: 128,
      img: require("./images/145.jpg"),
      uri: {uri: '145.pdf'},
    },
    {
      key: 129,
      img: require("./images/146.jpg"),
      uri: {uri: '146.pdf'},
    },
    {
      key: 130,
      img: require("./images/147.jpg"),
      uri: {uri: '147.pdf'},
    },
    {
      key: 131,
      img: require("./images/147pdftricou.jpg"),
      uri: {uri: '1947.jpg'},
    },
    {
      key: 132,
      img: require("./images/147v2.jpg"),
      uri: {uri: '147v2.pdf'},
    },
    {
      key: 133,
      img: require("./images/149.jpg"),
      uri: {uri: '149.pdf'},
    },
    {
      key: 134,
      img: require("./images/150.jpg"),
      uri: {uri: '150.pdf'},
    },
    {
      key: 135,
      img: require("./images/152.jpg"),
      uri: {uri: '152.pdf'},
    },
    {
      key: 136,
      img: require("./images/153.jpg"),
      uri: {uri: '153.pdf'},
    },
    {
      key: 137,
      img: require("./images/154.jpg"),
      uri: {uri: '154.pdf'},
    },
    {
      key: 138,
      img: require("./images/155.jpg"),
      uri: {uri: '155.pdf'},
    },
    {
      key: 139,
      img: require("./images/156.jpg"),
      uri: {uri: '156.pdf'},
    },
    {
      key: 140,
      img: require("./images/157.jpg"),
      uri: {uri: '157.pdf'},
    },
    {
      key: 141,
      img: require("./images/158.jpg"),
      uri: {uri: '158.pdf'},
    },
    {
      key: 142,
      img: require("./images/160.jpg"),
      uri: {uri: '160.pdf'},
    },
    {
      key: 143,
      img: require("./images/161.jpg"),
      uri: {uri: '161.pdf'},
    },
    {
      key: 144,
      img: require("./images/162.jpg"),
      uri: {uri: '162.pdf'},
    },
    {
      key: 145,
      img: require("./images/163.jpg"),
      uri: {uri: '163.pdf'},
    },
    {
      key: 146,
      img: require("./images/164.jpg"),
      uri: {uri: '164.pdf'},
    },
    {
      key: 147,
      img: require("./images/165.jpg"),
      uri: {uri: '165.pdf'},
    },
    {
        key: 148,
        img: require("./images/166.jpg"),
        uri: {uri: '166.pdf'},
      },
      {
        key: 149,
        img: require("./images/167.jpg"),
        uri: {uri: '167.pdf'},
      },
      {
        key: 150,
        img: require("./images/4151.jpg"),
        uri: {uri: '4151.jpg'},
      },
      {
        key: 151,
        img: require("./images/craniu47csa.jpg"),
        uri: {uri: 'craniu47csa.tif'},
      },
      {
        key: 152,
        img: require("./images/steauadungi1947.jpg"),
        uri: {uri: 'steauadungi1947.tif'},
      },
      {
        key: 153,
        img: require("./images/steauahexagon.jpg"),
        uri: {uri: 'steauahexagon.tif'},
      },
      {
        key: 154,
        img: require("./images/steauasimplucsa.jpg"),
        uri: {uri: 'steauasimplucsa.tif'},
      },
      {
        key: 155,
        img: require("./images/sudtif.jpg"),
        uri: {uri: 'sud.tif'},
      },

    
  ]


  export default data;